import { StyledButton } from './styles';

export default function ButtonBase({ icon, text, btnTheme, disabled, ...restProps }) {
  return (
    <StyledButton startIcon={icon} btnTheme={btnTheme} disabled={disabled} disableRipple {...restProps}>
      <span className="btn-text">{text}</span>
    </StyledButton>
  );
}
